import { createSlice } from '@reduxjs/toolkit'
import { guid } from 'apps/builder/lib/utils'

import {
  deleteLiveDataEntry,
  updateDataSourceParam,
  createDataSourceParam,
} from 'apps/formsCreationKit/store/actions/sharedActions'

import { saveApp } from 'apps/formsCreationKit/store/reducers/settings/appSettings'

import { actions as clientActions } from '@gocanvas/client'
const { loadFormData } = clientActions

export const initialState = []

const extraDataSourceContextParamsActions = builder => {
  builder.addCase(loadFormData, (state, action) => {
    const { dataSourceParams } = action.payload
    return dataSourceParams
  })

  builder.addCase(createDataSourceParam, (state, action) => {
    const { data_source_param_id, data_source_context_id, value, entry_id } =
      action.payload

    return [
      ...state,
      {
        id: guid(),
        data_source_context_id,
        data_source_param_id,
        entry_id,
        value,
      },
    ]
  })

  builder.addCase(updateDataSourceParam, (state, action) => {
    const {
      id,
      entry_id,
      value,
      data_source_context_id,
      data_source_param_id,
    } = action.payload

    return state.map(param => {
      if (param.id !== id) return param
      return {
        ...param,
        data_source_context_id,
        data_source_param_id,
        entry_id,
        value,
      }
    })
  })

  builder.addCase(deleteLiveDataEntry, (state, action) => {
    const { data_source_context_id } = action.payload
    return state.filter(
      param => param.data_source_context_id !== data_source_context_id
    )
  })

  builder.addCase(saveApp.fulfilled, (state, action) => {
    const { entities } = action.payload
    const { dataSourceContextParams = [] } = entities
    return dataSourceContextParams
  })
}

export const dataSourceContextParamsSliceConfig = {
  name: 'dataSourceContextParams',
  initialState: initialState,
  reducers: {},
  extraReducers: extraDataSourceContextParamsActions,
}

export const dataSourceContextParamsSlice = createSlice(
  dataSourceContextParamsSliceConfig
)
export const {
  actions: dataSourceContextParamsActions,
  reducer: dataSourceContextParamsReducer,
} = dataSourceContextParamsSlice
